import { useState, useEffect, useRef } from 'react';

export default function Home() {
  const [activeTab, setActiveTab] = useState(0);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [showCustomerToolsDropdown, setShowCustomerToolsDropdown] = useState(false);
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showCallbackModal, setShowCallbackModal] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [heroSlide, setHeroSlide] = useState(0);
  const [heroFading, setHeroFading] = useState(false);

  const heroSlides = [
    {
      url: 'https://public.readdy.ai/ai/img_res/a6b9f423531b9c083e0b354bd8380e08.jpg',
      label: 'Bulut Bilişim Hizmetleri'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=professional%20IT%20management%20team%20monitoring%20multiple%20servers%20and%20cloud%20infrastructure%2C%20modern%20data%20center%20environment%2C%20technology%20specialists%20working%20with%20advanced%20monitoring%20systems&width=1920&height=800&seq=26&orientation=landscape',
      label: 'Yönetilen IT Hizmetleri'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=modern%20data%20center%20migration%20process%20with%20servers%20and%20cloud%20infrastructure%2C%20professional%20IT%20migration%20visualization%20with%20blue%20lighting%20and%20high-tech%20environment%2C%20digital%20transformation%20concept&width=1920&height=800&seq=30&orientation=landscape',
      label: 'Sistem Taşıma & Migration'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=professional%20IT%20consulting%20meeting%20with%20business%20executives%20and%20technology%20experts%20discussing%20digital%20strategy%2C%20modern%20corporate%20boardroom%20with%20charts%20and%20technology%20displays&width=1920&height=800&seq=31&orientation=landscape',
      label: 'IT Danışmanlık'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Professional%20IT%20support%20team%20working%20with%20computers%20and%20servers%20in%20modern%20office%20environment%2C%20technical%20support%20specialists%20helping%20customers%2C%20blue%20and%20white%20color%20scheme%2C%20clean%20modern%20workspace%20with%20multiple%20monitors%20and%20networking%20equipment&width=1920&height=800&seq=it-support-hero&orientation=landscape',
      label: 'IT Destek & Bakım'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Microsoft%20365%20office%20applications%20interface%20with%20modern%20workplace%20collaboration%20tools%2C%20professional%20business%20software%20environment%20with%20Teams%2C%20Outlook%2C%20SharePoint%20integration%2C%20clean%20modern%20design&width=1920&height=800&seq=25&orientation=landscape',
      label: 'Microsoft 365'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setHeroFading(true);
      setTimeout(() => {
        setHeroSlide((prev) => (prev + 1) % heroSlides.length);
        setHeroFading(false);
      }, 400);
    }, 3500);
    return () => clearInterval(interval);
  }, [heroSlides.length]);

  const testimonials = [
    {
      id: 1,
      company: 'İYTE Yaşam Merkezi',
      title:
        "İYTE Yaşam Merkezi, IT Altyapısını Nimbus Bilişim'e Emanet Etti",
      description:
        "İzmir Yüksek Teknoloji Enstitüsü (İYTE) Yaşam Merkezi, öğrencilere 7/24 kesintisiz erişim ve güvenli dijital ortam sağlamak amacıyla IT altyapısını Nimbus Bilişim'e emanet etti. Mevcut ağ yapısında yaşanan erişim sorunları ve yönetimsel zorluklar, daha modern, ölçeklenebilir ve güvenli bir altyapıya geçişi zorunlu kılıyordu. Nimbus Bilişim mühendisleri tarafından yürütülen proje kapsamında; kablolu ve kablosuz ağ altyapısı yeniden tasarlandı, güvenlik duvarı ve kullanıcı erişim yönetimi yapılandırmaları kurumsal standartlara uygun hale getirildi. Böylece 500'e yakın mühendislik öğrencisi, yüksek bant genişliğine sahip, kesintisiz ve güvenli bir internet hizmetine kavuştu.",
      image:
        'https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/72ca488141e7f17a82bf95e2a8e8095f.png',
      thumbnail:
        'https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/72ca488141e7f17a82bf95e2a8e8095f.png'
    },
    {
      id: 2,
      company: 'Girginer Oto Endüstri',
      title:
        "Girginer Oto Endüstri Dijital Dönüşümünü Nimbus Bilişim'e Emanet Etti",
      description:
        'Girginer Oto Endüstri, üretim tesislerinde artan dijitalleşme ihtiyacına yanıt vermek amacıyla IT altyapısını Nimbus Bilişim\'e emanet etti. Üretim sahasında bulunan otomasyon sistemleri, ofis ağı ve yönetim katı arasındaki iletişimi güçlendirmek için kurumsal ağ topolojisi, güvenlik duvarı (FortiGate) yapılandırması ve sunucu sanallaştırma altyapısı baştan sona yeniden tasarlandı. Nimbus Bilişim mühendisleri tarafından hayata geçirilen yeni yapı sayesinde; Tüm üretim birimlerinde yüksek erişim hızı ve kesintisiz bağlantı, Kurumsal veri güvenliği için KVKK ve 5651 uyumlu loglama altyapısı, Merkezi yedekleme ve izleme sistemleri ile tam kontrol ve sürdürülebilirlik sağlandı.',
      image:
        'https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/afac9047da8c85b120047841807526a4.png',
      thumbnail:
        'https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/afac9047da8c85b120047841807526a4.png'
    },
    {
      id: 3,
      company: 'Tora Makina',
      title: 'Tora Makina, IT Altyapısını Nimbus Bilişim ile Yeniledi',
      description:
        'Endüstriyel üretim sektöründe faaliyet gösteren Tora Makina, büyüyen operasyonlarını destekleyecek modern ve güvenli bir IT altyapısı oluşturmak amacıyla Nimbus Bilişim\'i tercih etti. Mevcut sistemlerdeki performans düşüklüğü, erişim sorunları ve veri yedekleme eksiklikleri tespit edilerek kapsamlı bir dijital dönüşüm planı uygulandı. Proje kapsamında: FortiGate güvenlik duvarı ve segmentasyon politikalarıyla ağ güvenliği yeniden yapılandırıldı, Active Directory tabanlı kullanıcı erişim ve yetkilendirme sistemi kuruldu, Veeam tabanlı veri yedekleme ve kurtarma altyapısı hayata geçirildi, tüm sistemler KVKK ve 5651 mevzuatına uygun hâle getirildi. Yeni mimari sayesinde Tora Makina, üretimden yönetime kadar tüm birimlerinde kesintisiz bağlantı, merkezi yönetim ve yüksek veri güvenliği sağladı.',
      image:
        'https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/b339d79cac83b1606c606dd2dd037217.png',
      thumbnail:
        'https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/b339d79cac83b1606c606dd2dd037217.png'
    },
    {
      id: 4,
      company: 'Union International',
      title: 'Union International - Sunucu Revizyonu ve Microsoft 365 Projesi',
      description:
        'Union International firması, Microsoft 365 altyapısının yeniden yapılandırılması, mevcut sunucu sistemlerinin revizyonu ve tüm BT altyapısının modernizasyonu kapsamında Nimbus Bulut Bilişim\'i tercih etmiştir. Proje kapsamında; 365 servislerinin kurumsal ihtiyaçlara uygun şekilde konfigürasyonu, mevcut sunucu yapısının performans ve güvenlik odaklı olarak yeniden tasarlanması, ağ altyapısının optimize edilmesi ve sistem bütünlüğünün sağlanması çalışmaları başarıyla tamamlanmıştır. Gerçekleştirilen bu dönüşüm ile Union International\'ın BT altyapısı daha güvenli, ölçeklenebilir ve sürdürülebilir bir yapıya kavuşturulmuştur.',
      image:
        'https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/291de4dbb91a94815abbc647abe5e2cb.png',
      thumbnail:
        'https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/291de4dbb91a94815abbc647abe5e2cb.png'
    },
    {
      id: 5,
      company: 'IŞIKCAM',
      title: 'IŞIKCAM – Network ve Sistem Altyapı Dönüşüm Projesi',
      description:
        'IŞIKCAM firması, network altyapısının modernizasyonu, server sistemlerinin yeniden yapılandırılması ve sistem odası revizyonu kapsamında Nimbus Bulut Bilişim\'i tercih etmiştir. Proje sürecinde mevcut ağ topolojisi analiz edilerek performans, güvenlik ve sürdürülebilirlik esaslarına göre yeniden tasarlanmış; aktif cihaz konfigürasyonları, kabinet düzenlemeleri ve sistem odası iyileştirmeleri profesyonel standartlara uygun şekilde gerçekleştirilmiştir. Sunucu altyapısı güncellenerek veri güvenliği, yedeklilik ve iş sürekliliği öncelikli bir yapı oluşturulmuş; tüm BT süreçleri uçtan uca IT sistem destek ve danışmanlık hizmeti kapsamında yönetilebilir hale getirilmiştir. Gerçekleştirilen çalışmalar ile IŞIKCAM\'ın bilgi teknolojileri altyapısı daha güvenli, ölçeklenebilir ve kurumsal bir seviyeye taşınmıştır.',
      image:
        'https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/ab2a8ae30a0fc82e48242360de14e6d5.png',
      thumbnail:
        'https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/ab2a8ae30a0fc82e48242360de14e6d5.png'
    },
    {
      id: 6,
      company: 'Can Kardeşler Kuruyemiş',
      title: 'Can Kardeşler Kuruyemiş – Uçtan Uca IT Altyapı Yönetimi',
      description:
        '4 üretim fabrikası ve 60 şubesi ile sektöründe güçlü bir konuma sahip olan Can Kardeşler Kuruyemiş, tüm bilgi teknolojileri altyapısının yönetimi ve geliştirilmesi konusunda Nimbus Bulut Bilişim\'i tercih etmiştir. Proje kapsamında; merkez ve şubeler arası network yapısının yeniden kurgulanması, sunucu ve sanallaştırma altyapısının modernizasyonu, firewall ve güvenlik katmanlarının yapılandırılması, yedekleme ve iş sürekliliği senaryolarının oluşturulması ile uçtan uca IT sistem destek ve danışmanlık hizmetleri tarafımızca yürütülmektedir. Gerçekleştirilen çalışmalar ile Can Kardeşler Kuruyemiş\'in tüm lokasyonlarında güvenli, sürdürülebilir, merkezi olarak yönetilebilir ve ölçeklenebilir bir BT altyapısı oluşturulmuş; operasyonel verimlilik ve sistem güvenliği kurumsal standartlara taşınmıştır.',
      image:
        'https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/1d217c3aa98353680128d5a78850bfad.png',
      thumbnail:
        'https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/1d217c3aa98353680128d5a78850bfad.png'
    }
  ];

  const faqs = [
    {
      question: "IT firması nedir ve ne yapar?",
      answer: "IT firması, işletmelerin bilgi teknolojileri ihtiyaçlarını karşılayan profesyonel hizmetler sunar. Nimbus Bulut Bilişim, sunucu yönetimi, bulut bilişim, siber güvenlik, yazılım geliştirme ve IT danışmanlığı konularında uzmanlaşmış bir firmadır. Türkiye'nin yanı sıra global ölçekte çözümler sunar."
    },
    {
      question: "IT firması seçerken nelere dikkat edilmeli?",
      answer: "Referanslar, uzman kadro, 7/24 destek, kullanılan teknolojiler, güvenlik önlemleri ve ölçeklenebilir çözümler dikkat edilmesi gereken en önemli kriterlerdir."
    },
    {
      question: "IT firmaları hangi hizmetleri sunar?",
      answer: "Genellikle sunucu yönetimi, bulut çözümleri, siber güvenlik, yazılım geliştirme ve danışmanlık hizmetleri sunarlar. Nimbus Bulut Bilişim, bu hizmetlere ek olarak KVM tabanlı sanallaştırma çözümleri, özel entegrasyon projeleri ve güvenlik odaklı altyapı tasarımlarıyla öne çıkar."
    },
    {
      question: "IT firmaları Türkiye'de hangi sektörlere hizmet verir?",
      answer: "Finans, sağlık, lojistik, üretim ve eğitim gibi birçok sektöre hizmet verirler. Nimbus Bulut Bilişim, sektör fark etmeksizin her işletmeye özel çözümler geliştirir ve KOBİ'lerden kurumsal şirketlere kadar geniş bir müşteri portföyüne sahiptir."
    },
    {
      question: "IT hizmetleri küçük ve orta ölçekli işletmeler için uygun mu?",
      answer: "Evet. Nimbus Bulut Bilişim, KOBİ'lere uygun, uygun maliyetli ve ölçeklenebilir bulut çözümleri sunarak küçük işletmelerin kurumsal düzeyde IT altyapısına sahip olmasını sağlar."
    },
    {
      question: "IT firması ile çalışmanın avantajları nelerdir?",
      answer: "• Maliyetleri düşürür\\n• Profesyonel destek sağlar\\n• Güvenlik risklerini azaltır\\Nimbus Bulut Bilişim'in farkı, sadece teknik destek değil, aynı zamanda stratejik IT danışmanlığı sunmasıdır. İşletmenizin büyüme hedeflerine uygun ölçeklenebilir çözümler üretir."
    },
    {
      question: "Bulut tabanlı IT çözümleri neden tercih edilmeli?",
      answer: "Bulut sistemler, esnek depolama, yüksek performans, düşük maliyet, güvenlik ve her yerden erişim imkanı sunduğu için işletmeler tarafından tercih edilir."
    },
    {
      question: "IT firmaları ile uzun vadeli destek anlaşmaları yapılabilir mi?",
      answer: "Evet. Nimbus Bulut Bilişim, aylık, yıllık veya proje bazlı bakım & destek anlaşmaları sunar. Ayrıca proaktif izleme ve raporlama sistemleriyle IT sorunlarını oluşmadan önler."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white text-gray-900 sticky top-0 z-50 shadow-sm border-b border-gray-200">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center space-x-8">
              <a href="/" className="flex items-center space-x-3 cursor-pointer">
                <img
                  src="https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/7b7be6e694aa19d5c5f7abd74de9f9de.png"
                  alt="Nimbus Bilişim Logo"
                  className="h-24 w-auto"
                />
                <div className="text-lg text-gray-900">
                  Nimbus Bulut Bilişim Teknoloji ve Mühendislik
                </div>
              </a>

              <nav className="hidden lg:flex space-x-8">
                <div className="relative group">
                  <button
                    onClick={() => {
                      setShowServicesDropdown(!showServicesDropdown);
                      setShowCustomerToolsDropdown(false);
                    }}
                    className="flex items-center space-x-1 hover:text-blue-600 transition-colors whitespace-nowrap text-gray-700 cursor-pointer"
                  >
                    <span>IT Hizmetleri</span>
                    <i
                      className={`ri-arrow-${showServicesDropdown ? 'up' : 'down'}-s-line transition-transform`}
                    ></i>
                  </button>
                  {showServicesDropdown && (
                    <div className="absolute top-full left-0 mt-2 w-[1000px] bg-white rounded-lg shadow-lg border border-gray-200 py-6 z-50">
                      <div className="grid grid-cols-3 gap-8 px-8">
                        {/* IT Destek Hizmetleri */}
                        <div>
                          <h4 className="text-sm font-bold text-gray-900 mb-4 uppercase tracking-wide">
                            IT Destek Hizmetleri
                          </h4>
                          <div className="space-y-3">
                            <button
                              onClick={() => {
                                window.REACT_APP_NAVIGATE('/services/it-support');
                                setShowServicesDropdown(false);
                              }}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                            >
                              <div className="font-medium">IT Destek & Bakım Hizmetleri</div>
                              <div className="text-sm text-gray-500 mt-1">7/24 IT destek ve bakım hizmetleri</div>
                            </button>
                            <button
                              onClick={() => {
                                window.REACT_APP_NAVIGATE('/services/it-consultinging');
                                setShowServicesDropdown(false);
                              }}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                            >
                              <div className="font-medium">IT Danışmanlık Hizmetleri</div>
                              <div className="text-sm text-gray-500 mt-1">Profesyonel danışmanlık</div>
                            </button>
                          </div>
                        </div>

                        {/* Bulut Bilişim Hizmetleri */}
                        <div>
                          <h4 className="text-sm font-bold text-gray-900 mb-4 uppercase tracking-wide">
                            Bulut Bilişim Hizmetleri
                          </h4>
                          <div className="space-y-3">
                            <button
                              onClick={() => {
                                window.REACT_APP_NAVIGATE('/services/virtual-server');
                                setShowServicesDropdown(false);
                              }}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                            >
                              <div className="font-medium">Bulut Bilişim Hizmetleri</div>
                              <div className="text-sm text-gray-500 mt-1">Kurumsal bulut sunucu hizmetleri</div>
                            </button>
                            <button
                              onClick={() => {
                                window.REACT_APP_NAVIGATE('/services/managed-it');
                                setShowServicesDropdown(false);
                              }}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                            >
                              <div className="font-medium">Yönetilen IT Hizmetleri</div>
                              <div className="text-sm text-gray-500 mt-1">Tüm yönetim hizmetleri</div>
                            </button>
                            <button
                              onClick={() => {
                                window.REACT_APP_NAVIGATE('/services/migration');
                                setShowServicesDropdown(false);
                              }}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                            >
                              <div className="font-medium">Sistem Taşıma ve Geçiş Hizmetleri (Migration)</div>
                              <div className="text-sm text-gray-500 mt-1">Sunucu taşıma hizmetleri</div>
                            </button>
                          </div>
                        </div>

                        {/* Microsoft 365 Hizmetleri */}
                        <div>
                          <h4 className="text-sm font-bold text-gray-900 mb-4 uppercase tracking-wide">
                            Microsoft 365 Hizmetleri
                          </h4>
                          <div className="space-y-3">
                            <button
                              onClick={() => {
                                window.REACT_APP_NAVIGATE('/services/microsoft-365');
                                setShowServicesDropdown(false);
                              }}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                            >
                              <div className="font-medium">Microsoft 365 Geçiş ve Yönetimi</div>
                              <div className="text-sm text-gray-500 mt-1">Azure Expert hizmetleri</div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <button
                  onClick={() => {
                    const el = document.getElementById('basari-hikayeleri');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="hover:text-blue-600 transition-colors whitespace-nowrap text-gray-700 cursor-pointer"
                >
                  Başarı Hikayeleri
                </button>
                <button
                  onClick={() => window.REACT_APP_NAVIGATE('/about')}
                  className="hover:text-blue-600 transition-colors whitespace-nowrap text-gray-700 cursor-pointer"
                >
                  Hakkımızda
                </button>
                <button
                  onClick={() => {
                    const el = document.getElementById('sss');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="hover:text-blue-600 transition-colors whitespace-nowrap text-gray-700 cursor-pointer"
                >
                  SSS
                </button>
              </nav>
            </div>
            <div className="flex items-center space-x-4">
              <div className="hidden lg:flex items-center space-x-4 ml-8">
                <div className="relative group">
                  <button
                    onClick={() => {
                      setShowCustomerToolsDropdown(!showCustomerToolsDropdown);
                      setShowServicesDropdown(false);
                    }}
                    className="flex items-center space-x-1 hover:text-blue-600 transition-colors whitespace-nowrap text-gray-700 cursor-pointer"
                  >
                    <span>Müşteri Araçları</span>
                    <i
                      className={`ri-arrow-${showCustomerToolsDropdown ? 'up' : 'down'}-s-line transition-transform`}
                    ></i>
                  </button>
                  {showCustomerToolsDropdown && (
                    <div className="absolute top-full right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                      <button
                        onClick={() => window.REACT_APP_NAVIGATE('/portal')}
                        className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors text-gray-700 cursor-pointer"
                      >
                        <div className="font-medium">Müşteri Portalı</div>
                        <div className="text-sm text-gray-500">
                          Fatura ve destek yönetimi
                        </div>
                      </button>
                      <a
                        href="mailto:destek@nimbusbilisim.com"
                        className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors text-gray-700 cursor-pointer block"
                      >
                        <div className="font-medium">7/24 Destek Hattı</div>
                        <div className="text-sm text-gray-500">
                          destek@nimbusbilisim.com
                        </div>
                      </a>
                      <a
                        href="https://rustdesk.com/download"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors text-gray-700 cursor-pointer block"
                      >
                        <div className="font-medium">RustDesk İndir</div>
                        <div className="text-sm text-gray-500">
                          Uzaktan destek programı
                        </div>
                      </a>
                      <button
                        onClick={() => {
                          setShowCallbackModal(true);
                          setShowCustomerToolsDropdown(false);
                        }}
                        className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors text-gray-700 cursor-pointer"
                      >
                        <div className="font-medium">Geri Arama Talebi</div>
                        <div className="text-sm text-gray-500">
                          Uzmanlarımızla görüşün
                        </div>
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <button
                onClick={() => setShowContactModal(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                İletişim
              </button>
              <a
                href="https://www.linkedin.com/company/nimbus-bulut-bili%C5%9Fim-teknoloji-yaz%C4%B1l%C4%B1m-ve-m%C3%BChendislik-a-%C5%9F/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-2xl"></i>
              </a>
              <button
                onClick={() => setShowMobileMenu(true)}
                className="lg:hidden cursor-pointer"
              >
                <i className="ri-menu-line text-2xl"></i>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Click outside to close dropdowns */}
      {(showServicesDropdown || showCustomerToolsDropdown) && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => {
            setShowServicesDropdown(false);
            setShowCustomerToolsDropdown(false);
          }}
        ></div>
      )}

      {/* Mobile Menu */}
      {showMobileMenu && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => setShowMobileMenu(false)}
          ></div>
          <div className="absolute right-0 top-0 h-full w-80 bg-white shadow-xl overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-8">
                <h3 className="text-xl font-bold text-gray-900">Menü</h3>
                <button
                  onClick={() => setShowMobileMenu(false)}
                  className="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>

              <nav className="space-y-6">
                <div>
                  <h4 className="text-sm font-semibold text-gray-500 uppercase mb-3">
                    IT Hizmetleri
                  </h4>
                  <div className="space-y-2">
                    <button
                      onClick={() => {
                        window.REACT_APP_NAVIGATE('/services/it-support');
                        setShowMobileMenu(false);
                      }}
                      className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                    >
                      <div className="font-medium">
                        IT Destek & Bakım Hizmetleri
                      </div>
                      <div className="text-sm text-gray-500">
                        7/24 IT destek ve bakım hizmetleri
                      </div>
                    </button>
                    <button
                      onClick={() => {
                        window.REACT_APP_NAVIGATE('/services/it-consulting');
                        setShowMobileMenu(false);
                      }}
                      className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                    >
                      <div className="font-medium">IT Danışmanlık Hizmetleri</div>
                      <div className="text-sm text-gray-500">
                        Profesyonel danışmanlık
                      </div>
                    </button>
                    <button
                      onClick={() => {
                        window.REACT_APP_NAVIGATE('/services/virtual-server');
                        setShowMobileMenu(false);
                      }}
                      className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                    >
                      <div className="font-medium">Bulut Bilişim Hizmetleri</div>
                      <div className="text-sm text-gray-500">
                        Kurumsal bulut sunucu hizmetleri
                      </div>
                    </button>
                    <button
                      onClick={() => {
                        window.REACT_APP_NAVIGATE('/services/managed-it');
                        setShowMobileMenu(false);
                      }}
                      className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                    >
                      <div className="font-medium">Yönetilen IT Hizmetleri</div>
                      <div className="text-sm text-gray-500">
                        Tüm yönetim hizmetleri
                      </div>
                    </button>
                    <button
                      onClick={() => {
                        window.REACT_APP_NAVIGATE('/services/microsoft-365');
                        setShowMobileMenu(false);
                      }}
                      className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                    >
                      <div className="font-medium">Microsoft 365 Geçiş ve Yönetimi</div>
                      <div className="text-sm text-gray-500">
                        Azure Expert hizmetleri
                      </div>
                    </button>
                    <button
                      onClick={() => {
                        window.REACT_APP_NAVIGATE('/services/migration');
                        setShowMobileMenu(false);
                      }}
                      className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                    >
                      <div className="font-medium">Sistem Taşıma ve Geçiş</div>
                      <div className="text-sm text-gray-500">
                        Sunucu taşıma hizmetleri
                      </div>
                    </button>
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-6">
                  <h4 className="text-sm font-semibold text-gray-500 uppercase mb-3">
                    Şirket
                  </h4>
                  <div className="space-y-2">
                    <button
                      onClick={() => {
                        setShowMobileMenu(false);
                        setTimeout(() => {
                          const el = document.getElementById('basari-hikayeleri');
                          if (el) el.scrollIntoView({ behavior: 'smooth' });
                        }, 50);
                      }}
                      className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                    >
                      Başarı Hikayeleri
                    </button>
                    <button
                      onClick={() => {
                        window.REACT_APP_NAVIGATE('/about');
                        setShowMobileMenu(false);
                      }}
                      className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                    >
                      Hakkımızda
                    </button>
                    <button
                      onClick={() => {
                        setShowMobileMenu(false);
                        setTimeout(() => {
                          const el = document.getElementById('sss');
                          if (el) el.scrollIntoView({ behavior: 'smooth' });
                        }, 50);
                      }}
                      className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                    >
                      SSS
                    </button>
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-6">
                  <h4 className="text-sm font-semibold text-gray-500 uppercase mb-3">
                    Müşteri Araçları
                  </h4>
                  <div className="space-y-2">
                    <button
                      onClick={() => {
                        window.REACT_APP_NAVIGATE('/portal');
                        setShowMobileMenu(false);
                      }}
                      className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                    >
                      <div className="font-medium">Müşteri Portalı</div>
                      <div className="text-sm text-gray-500">
                        Fatura ve destek yönetimi
                      </div>
                    </button>
                    <a
                      href="mailto:destek@nimbusbilisim.com"
                      className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors text-gray-700 cursor-pointer block"
                    >
                      <div className="font-medium">7/24 Destek Hattı</div>
                      <div className="text-sm text-gray-500">
                        destek@nimbusbilisim.com
                      </div>
                    </a>
                    <a
                      href="https://rustdesk.com/download"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors text-gray-700 cursor-pointer block"
                    >
                      <div className="font-medium">RustDesk İndir</div>
                      <div className="text-sm text-gray-500">
                        Uzaktan destek programı
                      </div>
                    </a>
                    <button
                      onClick={() => {
                        setShowCallbackModal(true);
                        setShowMobileMenu(false);
                      }}
                      className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                    >
                      <div className="font-medium">Geri Arama Talebi</div>
                      <div className="text-sm text-gray-500">
                        Uzmanlarımızla görüşün
                      </div>
                    </button>
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-6">
                  <button
                    onClick={() => {
                      setShowContactModal(true);
                      setShowMobileMenu(false);
                    }}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                  >
                    İletişim
                  </button>
                </div>
              </nav>
            </div>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="relative bg-gray-900 text-white py-40 lg:py-48 overflow-hidden min-h-[700px] flex items-center">
        <style>{`
          @keyframes slowPan {
            0% { transform: scale(1) translateX(-2%); }
            100% { transform: scale(1.1) translateX(2%); }
          }
        `}</style>
        {/* Slideshow Background */}
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className="absolute inset-0 w-full h-full"
            style={{
              opacity: index === heroSlide ? (heroFading ? 0 : 1) : 0,
              transition: 'opacity 0.4s ease-in-out',
              zIndex: 1,
            }}
          >
            <div
              className="absolute inset-0 w-full h-full bg-cover bg-center"
              style={{
                backgroundImage: `url('${slide.url}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                opacity: 0.28,
                animation: index === heroSlide ? 'slowPan 6s ease-in-out infinite alternate' : 'none',
              }}
            />
          </div>
        ))}
        {/* Animated IT Canvas Background */}
        <canvas
          ref={canvasRef}
          className="absolute inset-0 w-full h-full"
          style={{ zIndex: 2 }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/60 to-gray-900/70" style={{ zIndex: 3 }}></div>

        {/* Slide indicators */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center space-x-2" style={{ zIndex: 10 }}>
          {heroSlides.map((slide, index) => (
            <button
              key={index}
              onClick={() => { setHeroFading(true); setTimeout(() => { setHeroSlide(index); setHeroFading(false); }, 300); }}
              className="group flex flex-col items-center cursor-pointer"
              title={slide.label}
            >
              <div className={`h-1 rounded-full transition-all duration-300 ${index === heroSlide ? 'w-8 bg-white' : 'w-3 bg-white/40 hover:bg-white/70'}`} />
            </button>
          ))}
        </div>

        {/* Slide label */}
        <div className="absolute bottom-10 right-8 hidden lg:flex items-center" style={{ zIndex: 10 }}>
          <div className="flex items-center space-x-3 bg-black/40 backdrop-blur-sm border border-white/20 rounded-xl px-5 py-3">
            <div className="w-2 h-2 rounded-full bg-teal-400 shadow-[0_0_8px_rgba(20,184,166,0.9)] animate-pulse flex-shrink-0"></div>
            <span className="text-white font-semibold text-base tracking-wide">{heroSlides[heroSlide].label}</span>
          </div>
        </div>

        <div className="relative z-10 container mx-auto px-4 w-full" style={{ zIndex: 5 }}>
          <div className="max-w-4xl">
            <p className="text-blue-400 text-lg mb-6">İşinizi Nimbus ile Geleceğe Taşıyın</p>
            <h1 className="text-5xl lg:text-6xl font-bold mb-8">Türkiye'nin Önde Gelen IT Firması</h1>
            <p className="text-xl mb-12 leading-relaxed">
              IT operasyonlarınızı maksimum verimlilikle tek noktadan yönetin. <strong>Kurumsal Bulut Sunucu</strong> çözümleri, <strong>7/24 uzman IT desteği</strong> ve kapsamlı <strong>Microsoft 365 yönetim hizmetleri</strong> ile Nimbus Bulut Bilişim, işletmenizin tüm IT ihtiyaçları için tek güvenilir adrestir.
            </p>
            <button 
              onClick={() => setShowQuoteModal(true)}
              className="bg-blue-600 hover:bg-blue-700 px-8 py-4 rounded-lg text-lg font-semibold transition-colors flex items-center space-x-2 whitespace-nowrap cursor-pointer"
            >
              <span>Fiyat Teklifi Alın</span>
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Success Stories Section */}
      <section id="basari-hikayeleri" className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900">Başarı Hikayelerimiz / Müşteri Yorumları</h2>
          </div>
          
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="p-8">
              <div className="grid lg:grid-cols-2 gap-8 items-center">
                <div>
                  <img 
                    src={testimonials[activeTab].thumbnail}
                    alt={testimonials[activeTab].company}
                    className="w-full h-48 object-cover rounded-lg mb-6"
                  />
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{testimonials[activeTab].title}</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">{testimonials[activeTab].description}</p>
                  <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors whitespace-nowrap">
                    Referanslar
                  </button>
                </div>
                <div>
                  <img 
                    src={testimonials[activeTab].image} 
                    alt={testimonials[activeTab].company}
                    className="w-full h-96 object-cover rounded-lg"
                  />
                </div>
              </div>
            </div>
            
            <div className="bg-gray-100 p-6">
              <div className="flex space-x-4 overflow-x-auto">
                {testimonials.map((testimonial, index) => (
                  <button
                    key={testimonial.id}
                    onClick={() => setActiveTab(index)}
                    className={`flex-shrink-0 rounded-lg overflow-hidden transition-all ${
                      activeTab === index ? 'ring-4 ring-blue-500' : 'opacity-70 hover:opacity-100'
                    }`}
                  >
                    <img 
                      src={testimonial.thumbnail} 
                      alt={testimonial.company}
                      className="w-32 h-20 object-cover"
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900">İstanbul ve Türkiye Genelinde IT Firması Hizmetleri</h2>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20server%20room%20with%20virtual%20cloud%20infrastructure%2C%20professional%20IT%20data%20center%20with%20glowing%20blue%20servers%2C%20high-tech%20network%20equipment%2C%20clean%20organized%20cables%2C%20futuristic%20technology%20atmosphere%2C%20corporate%20business%20environment%2C%20realistic%20photography%20style%2C%20soft%20blue%20lighting&width=400&height=300&seq=virtual-server-1&orientation=landscape"
                alt="Sanal Sunucu Hizmetleri"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Sanal Sunucu Hizmetleri</h3>
                <p className="text-gray-600 mb-6">
                  Nimbus Bulut Bilişim olarak, sanal sunucu yönetimini sizin için güvenle üstleniyor, güvenlik, güncellemeler ve yedekleme gibi tüm kritik detayları titizlikle yönetiyoruz.
                </p>
                <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors flex items-center space-x-2 whitespace-nowrap">
                  <span>Sanal Sunucu Hizmetleri</span>
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=Microsoft%20365%20cloud%20services%20illustration%2C%20modern%20office%20collaboration%20tools%2C%20Teams%20SharePoint%20OneDrive%20icons%2C%20professional%20business%20workspace%2C%20clean%20minimalist%20design%2C%20blue%20and%20white%20color%20scheme%2C%20corporate%20technology%20concept%2C%20realistic%203D%20style&width=400&height=300&seq=microsoft-365-1&orientation=landscape"
                alt="Microsoft 365 Hizmetleri"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Microsoft 365 Hizmetleri</h3>
                <p className="text-gray-600 mb-6">
                  Nimbus Bulut Bilişim, Microsoft Office 365'in tüm potansiyelinden yararlanmanıza yardımcı olmak için uzman rehberlik, yönetim ve destek sağlar.
                </p>
                <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors flex items-center space-x-2 whitespace-nowrap">
                  <span>Microsoft 365 Hizmetleri</span>
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <img 
                src="https://readdy.ai/api/search-image?query=IT%20support%20team%20helping%20business%20professionals%2C%20technical%20support%20specialists%20working%20on%20computers%2C%20modern%20office%20environment%2C%20customer%20service%20concept%2C%20professional%20corporate%20setting%2C%20friendly%20helpful%20atmosphere%2C%20realistic%20photography%20style%2C%20warm%20lighting&width=400&height=300&seq=it-support-1&orientation=landscape"
                alt="IT Destek Hizmetleri"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">IT Destek ve Bakım Hizmetleri</h3>
                <p className="text-gray-600 mb-6">
                  Nimbus Bulut Bilişim, müşteri deneyimlerine odaklanan ve kullanıcılarınıza gerçek katma değer sağlayan kapsamlı 7/24 IT Destek ve Bakım hizmetleri sunar.
                </p>
                <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors flex items-center space-x-2 whitespace-nowrap">
                  <span>IT Destek Hizmetleri</span>
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="sss" className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900">Sıkça Sorulan Sorular</h2>
            </div>
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div key={index} className="bg-white rounded-lg shadow-sm">
                  <button
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="font-semibold text-gray-900">{faq.question}</h3>
                    <i className={`ri-arrow-${openFaq === index ? 'up' : 'down'}-s-line text-gray-500 transition-transform`}></i>
                  </button>
                  {openFaq === index && (
                    <div className="px-6 pb-4">
                      <p className="text-gray-600 leading-relaxed whitespace-pre-line">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Özelleştirilmiş hizmetler ve destek için bizimle iletişime geçin</h3>
            <p className="text-gray-600 mb-8">
              Size yardımcı olmaktan mutluluk duyacak ekip üyelerimizden biriyle iletişime geçin.
            </p>
            <button 
              onClick={() => setShowCallbackModal(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg transition-colors flex items-center space-x-2 mx-auto whitespace-nowrap cursor-pointer"
            >
              <span>Geri Arama Talebi</span>
              <i className="ri-phone-line"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white text-gray-900 py-12 border-t border-gray-200">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-3 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <img
                  src="https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/7b7be6e694aa19d5c5f7abd74de9f9de.png"
                  alt="Nimbus Bulut Bilişim"
                  className="h-24 w-auto"
                />
                <div className="text-lg text-gray-900">
                  Nimbus Bulut Bilişim Teknoloji ve Mühendislik
                </div>
              </div>
              <p className="text-gray-600 mb-4">İşinizi Geleceğe Taşıyın</p>
              <p className="text-gray-500 text-sm">© Tüm Hakları Saklıdır. • Nimbus Bulut Bilişim</p>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Hizmetler</h4>
              <nav className="space-y-3">
                <a href="/services/virtual-server" className="block text-gray-600 hover:text-blue-600 transition-colors">Sanal Sunucu Hizmetleri</a>
                <a href="/services/microsoft-365" className="block text-gray-600 hover:text-blue-600 transition-colors">Microsoft 365 Hizmetleri</a>
                <a href="/services/it-support" className="block text-gray-600 hover:text-blue-600 transition-colors">IT Destek ve Bakım</a>
                <a href="/about" className="block text-gray-600 hover:text-blue-600 transition-colors">Hakkımızda</a>
              </nav>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">İletişim</h4>
              <div className="space-y-4">
                <div>
                  <p className="text-gray-600 mb-2">İzmir, Türkiye</p>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-phone-line text-blue-600"></i>
                  <a href="tel:+905457913535" className="text-gray-600 hover:text-blue-600 transition-colors">
                    +90 545 791 35 35
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-mail-line text-blue-600"></i>
                  <a href="mailto:info@nimbusbilisim.com" className="text-gray-600 hover:text-blue-600 transition-colors">
                    info@nimbusbilisim.com
                  </a>
                </div>
              </div>
              <div className="mt-6">
                <a
                  href="https://readdy.ai/?ref=logo"
                  className="text-gray-400 hover:text-blue-600 transition-colors text-sm"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  Website Builder
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Quote Modal */}
      {showQuoteModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-2">
                <img
                  src="https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/7b7be6e694aa19d5c5f7abd74de9f9de.png"
                  alt="Nimbus Bilişim Logo"
                  className="h-14 w-auto"
                />
                <button onClick={() => setShowQuoteModal(false)} className="text-gray-500 hover:text-gray-700 cursor-pointer">
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Fiyat Teklifi Alın</h3>
              <form 
                id="quote-form"
                data-readdy-form
                action="https://readdy.ai/api/form/d6c0r7jv53dtlm7j7tdg"
                method="POST"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  fetch(form.action, {
                    method: 'POST',
                    body: new URLSearchParams(formData as any),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                  }).then(() => {
                    alert('Talebiniz başarıyla gönderildi!');
                    setShowQuoteModal(false);
                    form.reset();
                  });
                }}
                className="space-y-4"
              >
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Ad Soyad *</label>
                  <input type="text" name="name" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">E-posta *</label>
                  <input type="email" name="email" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Telefon *</label>
                  <input type="tel" name="phone" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Şirket Adı</label>
                  <input type="text" name="company" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">İlgilendiğiniz Hizmet</label>
                  <select name="service" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                    <option value="">Seçiniz</option>
                    <option value="Sanal Sunucu">Sanal Sunucu Hizmetleri</option>
                    <option value="Microsoft 365">Microsoft 365 Hizmetleri</option>
                    <option value="IT Destek">IT Destek ve Bakım</option>
                    <option value="IT Danışmanlık">IT Danışmanlık</option>
                    <option value="Yönetilen IT">Yönetilen IT Hizmetleri</option>
                    <option value="Migration">Sistem Taşıma ve Geçiş</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Mesajınız</label>
                  <textarea name="message" rows={4} maxLength={500} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"></textarea>
                  <p className="text-xs text-gray-500 mt-1">Maksimum 500 karakter</p>
                </div>
                <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors whitespace-nowrap">
                  Gönder
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Contact Modal */}
      {showContactModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-2">
                <img
                  src="https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/7b7be6e694aa19d5c5f7abd74de9f9de.png"
                  alt="Nimbus Bilişim Logo"
                  className="h-14 w-auto"
                />
                <button onClick={() => setShowContactModal(false)} className="text-gray-500 hover:text-gray-700 cursor-pointer">
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">İletişim</h3>
              <form 
                id="contact-form"
                data-readdy-form
                action="https://readdy.ai/api/form/d6c0r7jv53dtlm7j7te0"
                method="POST"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  fetch(form.action, {
                    method: 'POST',
                    body: new URLSearchParams(formData as any),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                  }).then(() => {
                    alert('Mesajınız başarıyla gönderildi!');
                    setShowContactModal(false);
                    form.reset();
                  });
                }}
                className="space-y-4"
              >
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Ad Soyad *</label>
                  <input type="text" name="name" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">E-posta *</label>
                  <input type="email" name="email" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Telefon</label>
                  <input type="tel" name="phone" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Konu *</label>
                  <input type="text" name="subject" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Mesajınız *</label>
                  <textarea name="message" rows={5} maxLength={500} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"></textarea>
                  <p className="text-xs text-gray-500 mt-1">Maksimum 500 karakter</p>
                </div>
                <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors whitespace-nowrap">
                  Gönder
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Callback Modal */}
      {showCallbackModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-2">
                <img
                  src="https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/7b7be6e694aa19d5c5f7abd74de9f9de.png"
                  alt="Nimbus Bilişim Logo"
                  className="h-14 w-auto"
                />
                <button onClick={() => setShowCallbackModal(false)} className="text-gray-500 hover:text-gray-700 cursor-pointer">
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Geri Arama Talebi</h3>
              <form 
                id="callback-form"
                data-readdy-form
                action="https://readdy.ai/api/form/d6c0r7jv53dtlm7j7td0"
                method="POST"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  fetch(form.action, {
                    method: 'POST',
                    body: new URLSearchParams(formData as any),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                  }).then(() => {
                    alert('Geri arama talebiniz alındı!');
                    setShowCallbackModal(false);
                    form.reset();
                  });
                }}
                className="space-y-4"
              >
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Ad Soyad *</label>
                  <input type="text" name="name" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Telefon *</label>
                  <input type="tel" name="phone" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">E-posta</label>
                  <input type="email" name="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Uygun Arama Saati</label>
                  <select name="preferred_time" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                    <option value="">Seçiniz</option>
                    <option value="09:00-12:00">09:00 - 12:00</option>
                    <option value="12:00-15:00">12:00 - 15:00</option>
                    <option value="15:00-18:00">15:00 - 18:00</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Notlar</label>
                  <textarea name="notes" rows={3} maxLength={500} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"></textarea>
                  <p className="text-xs text-gray-500 mt-1">Maksimum 500 karakter</p>
                </div>
                <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors whitespace-nowrap">
                  Gönder
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
